import axios from '../utils/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const getAppointment = (clinicId, date = new Date().toISOString().split('T')[0], doctorId) => {
    const params = new URLSearchParams({ date });

    if (doctorId) {
        params.set('doctorId', String(doctorId));
    }

    return axios.get(`${API_URL}clinics/${clinicId}/appointments?${params.toString()}`);
};

const updateAppointmentStatus = (clinicId, appointmentId, status) =>
    axios.patch(`${API_URL}clinics/${clinicId}/appointments/${appointmentId}?status=${status}`);

const getAppointmentNotes = (clinicId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/appointments/notes?${params.toString()}`);
};

const saveAppointmentNotes = (clinicId, notes) =>
    axios.post(`${API_URL}clinics/${clinicId}/appointments/notes`, notes);

const deleteAppointmentNotes = (clinicId, notesId) =>
    axios.delete(`${API_URL}clinics/${clinicId}/appointments/notes/${notesId}`);

const getCancellationFollowups = (clinicId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/appointments/cancellation-followups?${params.toString()}`);
};

const sendCancellationFollowups = (clinicId, reminders) =>
    axios.post(`${API_URL}clinics/${clinicId}/appointments/cancellation-followups/send`, { reminders });

const getThankYouFollowups = (clinicId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/appointments/thank-you-followups?${params.toString()}`);
};

const sendThankYouFollowups = (clinicId, reminders) =>
    axios.post(`${API_URL}clinics/${clinicId}/appointments/thank-you-followups/send`, { reminders });

const getSurveyFollowups = (clinicId, pageNo = 0, pageSize = 20) => {
    const params = new URLSearchParams({
        pageNo: String(pageNo),
        pageSize: String(pageSize),
    });

    return axios.get(`${API_URL}clinics/${clinicId}/appointments/survey-followups?${params.toString()}`);
};

const appointmentService = {
    getAppointment,
    updateAppointmentStatus,
    getAppointmentNotes,
    saveAppointmentNotes,
    deleteAppointmentNotes,
    getCancellationFollowups,
    sendCancellationFollowups,
    getThankYouFollowups,
    sendThankYouFollowups,
    getSurveyFollowups,
};

export default appointmentService;
